
export const GET_ALL_TECHNICIAS = `
  query{
    getAllTechnicians_ {
      message
      status
      technicians {
        id_technician
        id_user
        account_status
        tech_status
        full_name
        frontCard
        backCard
        photoCard
        email
        ci
        id_city
        phoneNumber
        name_city
        id_subcription_tech
        status_sub
        startDate
        endDate
        code_sub
      }
    }
  }
`;

export const FILTERS_TECHNICIAN = `
  query ($requestFilterTechnician: JSON) {
      filtersTechnician(requestFilterTechnician: $requestFilterTechnician) {
          message
          status
          technicians {
              id_technician
              id_user
              account_status
              tech_status
              status_sub
              full_name
              phoneNumber
              email
              ci
              id_city
              name_city
              code_sub
              startDate
              endDate
          }
      }
  }
`;